import React from 'react'
import { useParams } from 'react-router-dom'
import WorkorderDetails from './workorderDetails'

const styles = {
    container: {
        paddingTop: 5,
        paddingLeft: 5,
        paddingRight: 5,
    },
}
const AppWorkorders = () => {
    const urlParams = useParams()

    return (
        <div className="workorder-wrapper">
            <div style={styles.container}>
                <WorkorderDetails existingWorkorderId={urlParams.id}/>
            </div>
        </div>
    )
}

export default AppWorkorders
